enum EntryMethod {
  CancelOrXZReport = 0,
  Keyed = 1,
  Stripe = 2,
  Chip = 5,
  ContactlessChip = 7,
  Cash = 21,
  CardHolderNotPresent = 81,
  ContactlessStripe = 91,
  ContactlessOnDevice = 92
}

export default EntryMethod;
